import { ApiRef, createApiRef } from '@backstage/frontend-plugin-api';
import type { Award } from '@internal/plugin-neo4j-awards-common';

export type AwardsApi = {
  getAwards: (
    uid: string,
    name: string,
    owners: string[],
    recipients: string[],
  ) => Promise<Award[]>;
  /**
   * Uploading logos is not supported in the Neo4j fork. This method will
   * throw if called. Use public image URLs instead.
   */
  uploadLogo: (file: File) => Promise<{ location: string }>;
  save: (award: Award) => Promise<Award>;
  delete: (uid: string) => Promise<boolean>;
};

export const awardsApiRef: ApiRef<AwardsApi> = createApiRef<AwardsApi>({
  id: 'plugin.awards.service',
});
